<template>
  <div id="page-layout">
    <div id="page-header">
      <div class="page-title-layout">
        <p>{{$t('404.title')}}</p>
      </div>
    </div>
    <div class="simple-page-layout">
      <div class="big-title">{{$t('404.desc')}}</div>
      <button class="solid-button" type="button" v-on:click="goToHome()">
        {{$t('404.action')}}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      goToHome() {
        this.$router.push({name: 'home'});
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../style/global.scss';

  #page-layout {
    display: grid;
    grid-template-columns: 15% [content] auto 15%;
  }

  #page-header {
    @extend %common-header;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/pages/404.vue